import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaUltraMetadata = React.lazy(() =>
    import('../NebulaUltraMetadata')
);
const nebulaUltraMetadataRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_ULTRA_METADATA_PAGE,
        element: <NebulaUltraMetadata />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaUltraMetadataRoutesRegistry;
